import script from "./PaywallBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./PaywallBanner.vue?vue&type=script&setup=true&lang=js"

import "./PaywallBanner.vue?vue&type=style&index=0&id=5f3550a8&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f3550a8"]])

export default __exports__